import styled, { css } from 'styled-components/macro';
import { IInputSize, IInputState } from './types';
import { FormStateColors, FormWidths } from './constants';
import { MessageContainer } from './components';
import { Input } from './inputs/inputs.styled';
import { Textarea } from './text-area/text-area.styled';

export const Container = styled.div<{
  $state: IInputState;
  $width: IInputSize;
  $disabled: boolean;
}>`
  ${({ theme, $disabled, $state, $width }) => css`
    ${FormWidths[$width]};

    * {
      box-sizing: border-box;
    }

    & > *:not(:first-child) {
      margin-top: ${theme.spacings.xs};
    }

    ${Input}, ${Textarea} {
      border-color: ${FormStateColors(theme)[$state].border};
      background-color: ${theme.semantic.field.bg};
      color: ${theme.semantic.text.default};

      ::placeholder {
        color: ${theme.semantic.text.placeholder};
      }

      :focus {
        border-color: ${FormStateColors(theme)[$state].borderFocus};
      }

      :read-only {
        pointer-events: none;
      }

      :disabled {
        background-color: ${theme.semantic.field.bgDisabled};
        border-color: ${theme.semantic.border.disabled};
        color: ${theme.semantic.text.disabled};
      }
    }

    ${MessageContainer} {
      color: ${$disabled
        ? theme.semantic.text.disabled
        : FormStateColors(theme)[$state].text};
    }
  `}
`;
